module.exports = __webpack_public_path__ + "components/rewards/dragon-lodge/static/logo-2fbdc98002de489cd098119212bd75ea.jpg";